var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/NavigationModelRepo/NavigationBimFile.ts";
import * as t from 'io-ts';
import { createPredicate } from '../createPredicate';
import { Id } from '../Id';
import { ModelErrorCodeType } from '../ModelErrorCodeType';
import { BimFile } from '../ModelRepo';
import { Urn } from '../Urn';
export var NavigationBimFile;

(function (_NavigationBimFile) {
  var gstationType = 'GStationModelRepositoryBimFile';
  var bim360Type = 'BimFile';
  var isGStationBimFile = _NavigationBimFile.isGStationBimFile = createPredicate(gstationType);
  var isBimFile = _NavigationBimFile.isBimFile = createPredicate(bim360Type);
  var io = _NavigationBimFile.io = t.type({
    type: t.union([t.literal(gstationType), t.literal(bim360Type)]),
    versionId: t.number,
    versionName: t.number,
    author: t.union([t.string, t["null"]]),
    uploadDate: t.string,
    status: BimFile.Status.io,
    name: t.string,
    baseClassifierId: t.union([Id, t["null"]]),
    baseClassifierVersion: t.union([t.number, t["null"]]),
    errorCode: t.union([t.undefined, t["null"], ModelErrorCodeType]),
    projectUrn: Urn,
    parentFolderUrn: t.union([Urn, t["null"]]),
    urn: Urn
  });
})(NavigationBimFile || (NavigationBimFile = {}));